<app-item-content [instructionItemContentTemplate]="itemContentCustomInstructionBoxes" [row]="row" [startLabel]="startLabel" [endLabel]="endLabel" [showFrequency]="false"></app-item-content>
<ng-template #itemContentCustomInstructionBoxes let-instruction="instruction" let-overlaps="scheduledAndOverlapsSelectedDate">
	@if (overlaps) {
		<app-instruction-box>{{ instruction.rate.quantity }} {{ instruction.rate.unit }}</app-instruction-box>
		<app-instruction-box>{{ instruction.medicationRoute | medicationRouteName }}</app-instruction-box>
	}
</ng-template>